import React from 'react'
import { Col, Row } from 'react-bootstrap'

// Hooks
import { useState } from '../../../../hooks'

// Components
import ReportFormFilter from '../../Form/Filter'
import ReportTableReSampled from '../../Table/ReSampled'

const ReportContainerReSampled = () => {
  const [filter, setFilterState] = useState()

  const handleFilterChange = (filter) => {
    setFilterState(filter)
  }

  return (
    <Row>
      <Col className="mb-3">
        {filter ? (
          <ReportTableReSampled
            filter={filter}
            onFilterChange={handleFilterChange}
          />
        ) : (
          <ReportFormFilter
            onFilterChange={handleFilterChange}
            name="re_sampled"
          />
        )}
      </Col>
    </Row>
  )
}

export default ReportContainerReSampled
